module.exports = __webpack_public_path__ + "img/icon-logo.61dcf778.svg";